import styled from '@emotion/styled'

import { Container, type Space } from '@/components/Container'
import { HeadingM } from '@/components/Typography'
import { VisuallyHidden } from '@/components/VisuallyHidden'
import { CONFIG } from '@/styles/emotion.config'

interface Props {
  items: {
    highlightedNumber: string
    textAfterNumber: string
  }[]
  space?: Space
}

export const BigNumbersStyleBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 -1rem;

  .big-number__subtitle {
    display: flex;
    flex-direction: column;
  }

  .block-big-number:nth-of-type(2n) {
    background-color: #f2f0f0;
  }

  ${CONFIG.media.md} {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    margin: 0 auto;
    box-shadow: var(--theme-box-shadow);
  }
`

export const BigNumbersStyles = styled.div`
  padding: 1.5rem 0 1.5rem 3.5rem;

  ${CONFIG.media.md} {
    padding: 1.5rem;
  }
`
const BigNumbers = ({ items, space }: Props) => (
  <Container maxWidth="xg" spaceOut={space}>
    <BigNumbersStyleBlock>
      {items?.map((item, index) => (
        <BigNumbersStyles className="block-big-number" key={`bg-${index}`}>
          <HeadingM className="big-number__title" color="accent" aria-hidden>
            {item.highlightedNumber}
          </HeadingM>
          <HeadingM className="big-number__subtitle" color="dark-high" aria-hidden>
            {item.textAfterNumber}
          </HeadingM>
          <VisuallyHidden as="p">
            {`${item.highlightedNumber} ${item.textAfterNumber}`}
          </VisuallyHidden>
        </BigNumbersStyles>
      ))}
    </BigNumbersStyleBlock>
  </Container>
)

export default BigNumbers
